import * as React from "react";
import WpGraphqlSeo from "gatsby-plugin-wpgraphql-seo";
import { Helmet } from "react-helmet";
import { getFaqSchemaForPost } from "../data/faq-schema.data";
import { getSoftwareSchemaForPost } from "../data/software-schema.data";

const getAbsoluteUrl = (url) => {
    if (!url || typeof url !== "string") return null;

    try {
        return new URL(url, process.env.GATSBY_SITE_URL).toString();
    } catch {
        return null;
    }
};

const Seo = ({ post, pathname, canonical: canonicalOverride, ...props }) => {
    const canonical =
        getAbsoluteUrl(canonicalOverride) ||
        getAbsoluteUrl(post?.seo?.canonical) ||
        getAbsoluteUrl(post?.uri);
    const faqSchema = getFaqSchemaForPost(post, pathname);
    const softwareSchema = getSoftwareSchemaForPost(post, pathname);
    const additionalSchemas = [faqSchema, softwareSchema].filter(Boolean);
    const yoastSchema = post?.seo?.schema?.raw
        ? JSON.parse(post.seo.schema.raw)
        : null;
    const postSchema = additionalSchemas.length
        ? [yoastSchema, ...additionalSchemas].filter(Boolean)
        : undefined;

    return (
        <>
            <WpGraphqlSeo post={post} {...props} postSchema={postSchema} />
            <Helmet htmlAttributes={{ lang: "en" }} />
            {canonical && (
                <Helmet
                    link={[
                        {
                            rel: "canonical",
                            href: canonical,
                        },
                    ]}
                />
            )}
        </>
    );
};

export default Seo;
